import baseV3Service from './base/baseV3Service.js';

const createProspect = (payload, config) => {
    return baseV3Service.post("prospects", payload, config);
};
const getProspect = (id, config) => {
    return baseV3Service.get(`prospects/${id}`, config);
};
const updateProspect = (id, payload, config) => {
    return baseV3Service.put(`prospects/${id}`, payload, config);
};
const getProspects = (config) => {
    return baseV3Service.get("prospects", config);
};

export { createProspect, getProspect, getProspects, updateProspect };
